<template>
  <div class="assignment-view w-100">
    <folder-settings
      :folder-parent-id="folder.parentId"
      :folder-name="folder.name"
      :grading-details="folder.gradingDetails"
    >
      <folder-tags
        v-if="folder.gradingDetails"
        :grading-details="folder.gradingDetails"
      />
    </folder-settings>
    <essays-view />
  </div>
</template>

<script>
import EssaysView from "@/views/essays_view.vue";
import FolderSettings from "@/components/folders/folder_settings.vue";
import FolderTags from "@/components/folders/folder-tags.vue";
import onboardingVueEventMixin from "@/mixins/onboardingVueEventMixin";

export default {
  name: "FolderView",
  components: {
    FolderTags,
    EssaysView,
    FolderSettings,
  },

  // this.emitOnboardingEvent
  mixins: [onboardingVueEventMixin("onboarding:mounted:assignmentView")],

  inject: ["workspacesProvider"],

  computed: {
    folder() {
      return this.workspacesProvider.getFolderById(
        this.$route.params.workspaceKey,
        +this.$route.params.id
      );
    },
  },

  mounted() {
    this.emitOnboardingEvent();
  },
};
</script>

<style lang="scss" scoped>
.assignment-view {
  height: calc(100vh - 112px - var(--maintenance-height));
  display: flex;
  flex-direction: column;
}
</style>
